module.exports = __webpack_public_path__ + "02304e9b2d842bdabdda208f9cd977ed.png";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader!./src/img/demo/techan.png
// module id = 2406
// module chunks = 0